module.exports = __webpack_public_path__ + "static/media/bg-palm-river.92f4ce47.svg";